module.exports = __webpack_public_path__ + "static/media/Deposites.8323b701.svg";